// Review Swiper
function initReviews() {
  new Swiper(".review", {
    navigation: {
      nextEl: ".swiper-button-next.review_next",
      prevEl: ".swiper-button-prev.review_prev",
    },
    pagination: {
      el: ".swiper-pagination.review_pagi",
      clickable: true,
    },
  });
}

// Tab Slideshow Swiper
function initTabSlideshow() {
  new Swiper(".tabSlide", {
    navigation: {
      nextEl: ".swiper-button-next.tab_next",
      prevEl: ".swiper-button-prev.tab_prev",
    },
    pagination: {
      el: ".swiper-pagination.pagin-tab",
      clickable: true,
    },
  });
}

// Team Slider Swiper
function initTeamSlider() {
  new Swiper(".team_slider", {
    slidesPerView: 1,
    spaceBetween: 5,
    centeredSlides: false,
    pagination: {
      el: ".swiper-pagination.team-pagin",
      clickable: true,
    },
    navigation: {
      nextEl: ".swiper-button-next.next-team",
      prevEl: ".swiper-button-prev.prev-team",
    },
    breakpoints: {
      550: {
        slidesPerView: 1,
        spaceBetween: 20,
      },
      980: {
        slidesPerView: 3,
        spaceBetween: 30,
      },
      1200: {
        slidesPerView: 4,
        spaceBetween: 30,
      },
    },
  });
}

// Table Slide Swiper
function initTableSlide() {
  new Swiper(".table_slide", {
    slidesPerView: 2.2,
    spaceBetween: 5,
    centeredSlides: false,
    pagination: {
      el: ".swiper-pagination.table-pagin",
      type: 'progressbar',
      clickable: true,
    },
    breakpoints: {
      550: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
      980: {
        slidesPerView: 4,
        spaceBetween: 30,
      },
      1200: {
        slidesPerView: 7,
        spaceBetween: 0,
      },
    },
  });
}

// Compare Slide Swiper
function initCompareSlide() {
  new Swiper(".compare_slide", {
    slidesPerView: 1.2,
    spaceBetween: 5,
    centeredSlides: false,
    pagination: {
      el: ".swiper-pagination.compare-pagin",
      type: 'progressbar',
      clickable: true,
    },
    breakpoints: {
      550: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
      980: {
        slidesPerView: 4,
        spaceBetween: 30,
      },
      1200: {
        slidesPerView: 4,
        spaceBetween: 0,
      },
    },
  });
}

// Featured Product Slider
function initFeaProSlider() {
  new Swiper(".collPro_slider", {
    slidesPerView: 2,
    spaceBetween: 10,
    centeredSlides: false,
    pagination: {
      el: ".swiper-pagination.coll_pagi",
      clickable: true,
    },
    navigation: {
      nextEl: ".swiper-button-next.coll_next",
      prevEl: ".swiper-button-prev.coll_prev",
    },
    breakpoints: {
      550: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
      980: {
        slidesPerView: 4,
        spaceBetween: 30,
      },
      1200: {
        slidesPerView: 3,
        spaceBetween: 15,
      },
    },
  });
}

// Blog Slider
function initBlogSlider() {
  new Swiper(".blog_slider", {
    slidesPerView: 1.2,
    spaceBetween: 10,
    centeredSlides: false,
    pagination: {
      el: ".swiper-pagination.blogPagin",
      clickable: true,
    },
    navigation: {
      nextEl: ".swiper-button-next.blog_next",
      prevEl: ".swiper-button-prev.blog_prev",
    },
    breakpoints: {
      550: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
      980: {
        slidesPerView: 3,
        spaceBetween: 20,
      },
      1200: {
        slidesPerView: 3.5,
        spaceBetween: 40,
      },
    },
  });
}

// Collection Slide Main
function initCollslideMain() {
  new Swiper(".coll_slideMain", {
    slidesPerView: 1.2,
    spaceBetween: 10,
    centeredSlides: false,
    breakpoints: {
      550: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
      980: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
      1200: {
        slidesPerView: 2,
        spaceBetween: 40,
      },
    },
  });
}

// Initial Swiper load
function initAllSwipers() {
  initReviews();
  initTabSlideshow();
  initTeamSlider();
  initTableSlide();
  initCompareSlide();
  initFeaProSlider();
  initBlogSlider();
  initCollslideMain();
}

// On document ready
$(document).ready(function () {
  initAllSwipers();
  $(document).on('click', '.easify-product-options label,.tpo_option-input-inner', function() {
  $('.ctmPrice').removeClass('hidden');
});

});

// Re-init Swipers on Shopify section load
$(document).on('shopify:section:load', function () {
  initAllSwipers();
  $(document).on('click', '.easify-product-options label,.tpo_option-input-inner', function() {
  $('.ctmPrice').removeClass('hidden');
});

});

// Function to run your logic
function tagFrameSizeOption() {
  document.querySelectorAll('.tpo_option-html h2, .tpo_option-label span').forEach(el => {
    if (el.textContent.trim().includes('4. Select your frame size')) {
      el.closest('.tpo_option-container')?.classList.add('easify-step-4');
    }
  });
}

// Watch for dynamic changes inside .easify-product-options
const target = document.querySelector('.easify-product-options');

if (target) {
  // Run once on initial load
  tagFrameSizeOption();

  // Set up observer to detect new content
  const observer = new MutationObserver(() => {
    tagFrameSizeOption();
  });

  observer.observe(target, {
    childList: true,
    subtree: true,
  });
}


let timeout;
const observer = new MutationObserver(() => {
  clearTimeout(timeout);
  timeout = setTimeout(tagFrameSizeOption, 100); // run after 100ms of no changes
});




const menu = document.querySelector('.menu-drawer');
const widget = document.querySelector('#storerocket-widget');

function setZ() {
  widget.style.zIndex = menu.offsetParent ? '1' : '';
}

document.addEventListener('click', () => setTimeout(setZ, 300));
setZ();


